import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageCollection } from "../images";
import TextFX from "../helper/text-fx";

const Collection = () => {
    return (
      <Container bsPrefix="collection" as='section' className="bg-light position-relative py-5">
        <Container>
          <Row>
            <TextFX baseDelay={300} letterDelay={10} className="title-xlarge text-uppercase domino">Collection</TextFX>
            <div className="collection-item d-flex flex-wrap my-5">
              <div className="col-md-6 column-container">
                <div className="image-holder">
                  <img 
                    src={ImageCollection}
                    alt="collection" 
                    className="product-image img-fluid" 
                  />
                </div>
              </div>
              <div className="col-md-6 column-container bg-white">
                <div className="collection-content p-5 m-0 m-md-5">
                  <h3 className="element-title text-uppercase" style={{fontSize: '2rem'}}>Maintaining a clean work environment</h3>
                  <p>
                    We at Easysauces value a clean, healthy and serene work environment. 
                    Our lab, and factory equipments are always sterilized.
                    We ensure work ethics are upheld at all times.
                  </p>
                </div>
              </div>
            </div>
          </Row>
        </Container>
      </Container>
    );
  };
  
  export default Collection;